import Vue from 'vue';
import themeColorPlugin from '_lib/plugin/theme-color';
import SentryPlugin from './plugin/sentry-runtime';
import PerformanceCollect from './plugin/performance-collect';
import HeboxWebappEnv from './plugin/heybox-env';

window.$API_HOST = /debugmode|localhost/.test(window.origin)
  ? 'https://heybox.debugmode.cn'
  : 'https://api.xiaoheihe.cn';
window.$WEB_HOST = /debugmode|localhost/.test(window.origin)
  ? 'https://web.debugmode.cn'
  : 'https://web.xiaoheihe.cn';

/* 添加主题*/
if (USE_THEME) {
  Vue.use(themeColorPlugin);
}

if (IS_PRO) {
  Vue.config.productionTip = false;
  Vue.use(SentryPlugin);
  Vue.use(PerformanceCollect);
} else {
  Vue.config.productionTip = true;
  Vue.config.devtools = true;
  Vue.config.debug = true;
}

Vue.use(HeboxWebappEnv);

export default Vue;
